class Autocomplete {
    constructor(element, bloc, filtre, getData, callback, button) {
        this.element = element;
        this.getData = getData;
        this.callback = callback;
        this.lastValue = "";
        this.nbValue = 0;
        this.bloc = bloc;
        this.filtre = filtre;
        this.button = button;

        this.input = element.querySelector("input");
        this.filtre = element.dataset.filtre;
        this.value = "";
        this.currentHover = null;

        if (this.filtre && this.input) {
            this.input.addEventListener("keydown", e => this.keyDown(e));
            this.input.addEventListener("keyup", e => this.keyUp(e));
            this.input.addEventListener("blur", e => this.blur(e));
            this.input.addEventListener("focus", e => this.focus(e));

            if (this.button) {
                this.button.addEventListener("click", () => {
                    if (this.callback) {

                        if (this.liste && this.liste.querySelector(".current")) {
                            this.input.value = this.liste.querySelector(".current").innerHTML;
                        }

                        this.clear();
                        this.callback(this.input.value);
                    }
                })
            }
        }

        this.element.addEventListener("click", e => {
            if (e.target.tagName === "LI" && this.callback) {
                this.input.value = e.target.dataset.texte;
                this.callback(e.target.dataset.texte);
                this.clear();
            }
        })
    }

    keyDown(e) {
        if (e.which === 38) {
            e.preventDefault();
            this.currentHover = ((this.currentHover === null ? 0 : this.currentHover) - 1 + this.nbValue + 1) % (this.nbValue + 1);
            this.changeSelect();
        } else if (e.which === 40) {
            e.preventDefault();
            this.currentHover = ((this.currentHover === null ? -1 : this.currentHover) + 1 + this.nbValue + 1) % (this.nbValue + 1);
            this.changeSelect();
        } else if (e.which === 13) {
            e.preventDefault();
            if (this.callback) {

                if (this.liste && this.liste.querySelector(".current")) {
                    this.input.value = this.liste.querySelector(".current").dataset.texte;
                }

                this.clear();
                this.callback(this.input.value);
            }
        }
    }

    keyUp(e) {
        if (e.which === 13) {
            return;
        }

        this.value = this.input.value;
        if (this.lastValue !== this.value) {
            this.lastValue = this.value;
            this.currentHover = null;
        }
        this.render();
    }

    blur() {
        setTimeout(this.clear.bind(this), 200);
    }

    focus() {
        this.render();
    }

    changeSelect() {
        this.render();
    }

    clear() {
        if (this.liste) {
            this.element.removeChild(this.liste);
            this.liste = null;
        }
    }

    render() {
        this.clear();

        if (this.value.length >= 2) {
            let results = this.getData(this.bloc, this.filtre).filter(item => this.normalise(item[this.filtre]).indexOf(this.normalise(this.value)) > -1).filter((item, index) => index < 10);

            if (results.length > 0) {
                this.liste = document.createElement("ul");
                this.element.appendChild(this.liste);

                results.forEach((result, index) => {
                    let li = document.createElement("li");

                    if (this.currentHover !== null && index === this.currentHover) {
                        li.classList.add("current");
                    }

                    let texte = result[this.filtre];
                    let length = this.value.length;
                    let indexParse = this.normalise(texte).lastIndexOf(this.normalise(this.value));
                    while (indexParse > -1) {
                        texte = texte.substring(0, indexParse) + "<strong>" + texte.substring(indexParse, indexParse + length) + "</strong>" + texte.substring(indexParse + length);

                        indexParse = this.normalise(texte).lastIndexOf(this.normalise(this.value), indexParse);
                    }

                    li.innerHTML = texte;
                    li.dataset.texte = result[this.filtre];
                    this.liste.appendChild(li);

                    this.nbValue = index;
                })
            }
        }
    }

    normalise(string) {
        return string.toLowerCase().removeAccent();
    }
}

export default Autocomplete;


// WEBPACK FOOTER //
// ./src/scripts/components/autocomplete.js